webpackJsonp([20],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
module.exports = __webpack_require__(123);


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function gettopsenders() {
    showWait();

    var id = $('.roominfo').data('id');

    $('#senderslist').html('');
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/top-senders?max=30&channel_id=' + id,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function success(result) {
            if (result) {
                if (result.error == undefined) {
                    for (var i = 0; i < result.length; i++) {
                        var info = result[i];
                        var medalimg = '';
                        if (i == 0) {
                            medalimg = ROOT + '/static/images/goldmedal.png';
                        } else if (i == 1) {
                            medalimg = ROOT + '/static/images/silvermedal.png';
                        } else if (i == 2) {
                            medalimg = ROOT + '/static/images/bronzemedal.png';
                        } else {
                            medalimg = ROOT + '/static/images/othermedal.png';
                        }

                        var img = '';
                        if (info.avatar_url && info.avatar_url.length > 0) {
                            img = '<img src="' + info.avatar_url + '?w=40&h=40&s=1">';
                        }

                        var numHtml = '';
                        if (i < 3) {
                            numHtml = '<img src="' + medalimg + '">';
                        } else {
                            numHtml = i + 1;
                        }

                        var tr = '<tr><td class="list-medal">' + numHtml + '</td>' + '<td class="list-userimg">' + img + '</td>' + '<td><div class="list-username">' + info.nickname + '</div></td>' + '<td class="list-coin">' + info.coins + '</td></tr>';
                        $('#senderslist').append(tr);
                    }
                } else {
                    alert(result.message);
                }
            }
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function complete(XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
}

gettopsenders();

/***/ })

},[122]);


// WEBPACK FOOTER //
// js/topsender7e7971.js